import { isArray } from 'lodash';

/**  NavigationInformationItem */
export type NavigationInformationItem = { name: string; icon?: string; component?: string; value?: unknown };
/**
 * @author guan
 * @description  new NavigationInformation()定义一个导航信息
 * @return void
 */
export default class NavigationInformation {
    /** 被选中的样式 */
    static readonly onSelect = {
        color: '#4877fb',
        // borderRadius: '4px',
        boxShadow: ' 0px 0px 2px rgb(0 0 0 / 0.25) inset',
        // backgroundColor: 'rgb(0 0 0 / 0.02)',
    };
    /**正常的蓝色选择样式 */
    static readonly select = {
        backgroundColor: '#5783fb',
        color: '#fff',
    };
    /** 未选中的样式 */
    static readonly unSelect = {};
    /** 小型选项卡样式 */
    static readonly borderColor = {
        borderBottom: '1px solid #3ab9ff',
        color: '#5783fb',
    };

    /** 导航名称列表 */
    public Message!: NavigationInformationItem[];

    /** 当前选中的导航项 */
    private _active!: string;
    /** _active存取器 */
    get active(): string {
        return this._active;
    }
    /** _active存取器 */
    set active(value: string) {
        this._active = value;
    }
    /**
     * @author guan
     * @description style 的get方法
     * @return void
     */
    getStyle(value: string): typeof NavigationInformation.unSelect | typeof NavigationInformation.onSelect {
        if (this.active === value) {
            return NavigationInformation.onSelect;
        } else {
            return NavigationInformation.unSelect;
        }
    }
    /**
     * @author guan
     * @description style 的get方法
     * @return void
     */
    getStaticStyle(value: string): typeof NavigationInformation.unSelect | typeof NavigationInformation.onSelect {
        if (this.active === value) {
            return NavigationInformation.select;
        } else {
            return NavigationInformation.unSelect;
        }
    }
    /**
     * @author guan
     * @description style 的get方法
     * @return void
     */
    getItemStyle(value: string): typeof NavigationInformation.borderColor | void {
        if (this.active === value) {
            return NavigationInformation.borderColor;
        }
    }
    /** 获取当前状态下的值 */
    getValue(): unknown {
        const valueItem = this.Message.find((x) => {
            return x.name === this.active;
        });
        if (valueItem) return valueItem.value;
        else return '';
    }
    /**
     * @author guan
     * @description 获取对应的组件
     * @return 组件说明
     */
    getComponent(): string | void {
        const component = this.Message.find((x) => {
            return x.name === this.active;
        });
        if (!component) {
            throw new Error('未找到值，请检查错误');
        } else return component.component;
    }
    /**
     * @author: guan
     * @description: 通过值设置当前选中状态
     */
    setActiveByValue(value: string): void {
        const aim = this.Message.find((x) => x.value === value);
        if (aim) {
            this.active = aim.name;
        } else return;
    }
    /** 类的构造器 */
    constructor(name: NavigationInformationItem[], select: string) {
        if (!isArray(name)) {
            throw new Error('出错');
        }
        this.Message = name;
        this.active = select;
    }
}
